import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-10 h-10 rounded-md bg-primary-500 flex items-center justify-center shrink-0">
            <i className={`${icon} text-accent-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}